module.exports = __webpack_public_path__ + "static/media/waveform-path.66c83839.svg";